// extracted by mini-css-extract-plugin
export var bottomRichText = "PricingCards-module--bottomRichText--cf713";
export var card = "PricingCards-module--card--d6253";
export var leftSide = "PricingCards-module--leftSide--9fab9";
export var list = "PricingCards-module--list--bc0f2";
export var price = "PricingCards-module--price--ea76d";
export var richText = "PricingCards-module--richText--19907";
export var rightSide = "PricingCards-module--rightSide--e2f5d";
export var rightSideBottom = "PricingCards-module--rightSideBottom--1cb4b";
export var rightSideTop = "PricingCards-module--rightSideTop--3c5ef";
export var section = "PricingCards-module--section--3ffa2";
export var topRightRichtext = "PricingCards-module--topRightRichtext--96b86";
export var wrapper = "PricingCards-module--wrapper--b7951";